import { ProductGridTileFragment } from '@lib/graphql/graphql'
import clsx from 'clsx'
import { FC } from 'react'
import ProductCard from '../ProductCard/ProductCard'
import BlogPostCard, { BlogPostCardProps } from './BlogPostCard'
import s from './ProductGrid.module.scss'
import SkeletonCard from './SkeletonCard'
export interface DefaultGridProps {
  blogPosts?: BlogPostCardProps[]
  products?: ProductGridTileFragment[]
  loading?: boolean
  skeletonCount?: number
  minimumLoadingTime?: number // Add a prop for minimum loading time (in milliseconds)
  className?: string
  lcp?: boolean
  withoutIndexMap?: boolean
}
const DefaultGrid: FC<DefaultGridProps> = ({
  products,
  loading = false,
  skeletonCount = 12,
  blogPosts,
  className,
  withoutIndexMap,
  lcp,
}) => {
  return (
    <ul className={clsx(s.root, className)}>
      {loading &&
        Array.from({ length: skeletonCount }).map((_, idx) => (
          <SkeletonCard key={idx} />
        ))}
      {!loading &&
        products?.map((product, index) => {
          return (
            <ProductCard
              product={product}
              key={withoutIndexMap ? product.id : `${product.id}-${index}`}
              lcp={lcp && index < 4}
            />
          )
        })}
      {!loading &&
        blogPosts?.map((blogPost) => (
          <BlogPostCard
            title={blogPost.title}
            imageSrc={blogPost.imageSrc}
            linkSrc={blogPost.linkSrc}
            key={blogPost.title}
          />
        ))}
    </ul>
  )
}

export default DefaultGrid
